import _construct from "@babel/runtime/helpers/construct";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.concat.js";

/*----------------------------------------------------*/
// Dependencies

/*----------------------------------------------------*/
import { isArray } from 'lodash';
import { Defer } from './utils';
/*----------------------------------------------------*/
// Constants & Variables

/*----------------------------------------------------*/

var INSTANCE;
var defaults = {
  selector: '*[data-controller]',
  dataProp: 'controller'
};
var properties = {
  debug: false,
  promise: null,
  _controllers: [],
  components: new Map()
};
/*----------------------------------------------------*/
// Module

/*----------------------------------------------------*/

var Dispatcher = /*#__PURE__*/function () {
  function Dispatcher() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Dispatcher);

    if (INSTANCE) return INSTANCE;
    INSTANCE = this; // options

    this.options = Object.assign(Object.create(null), defaults, options); // properties

    Object.assign(this, properties); // remove useless prototypes

    if (typeof Object.setPrototypeOf !== 'undefined') {
      Object.setPrototypeOf(this.options, null);
    }

    return this;
  } // Application lifecycles
  // --------------------------------------------------


  _createClass(Dispatcher, [{
    key: "created",
    value: function created() {
      var promises = [];
      this.controllers.forEach(function (controller) {
        // eslint-disable-next-line no-underscore-dangle
        var delay = controller._delay || 0;

        var exec = function exec(resolve) {
          var promise = typeof controller.created === 'function' ? controller.created() : undefined;

          if (typeof promise !== 'undefined') {
            promise.then(resolve);
          } else {
            resolve();
          }
        };

        var boundPromise = new Promise(function (resolve) {
          if (delay > 0) {
            setTimeout(function () {
              exec(resolve);
            }, delay);
          } else {
            exec(resolve);
          }
        });
        promises.push(boundPromise);
      });
      return Promise.all(promises);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.controllers.forEach(function (controller) {
        if (typeof controller.destroy === 'function') {
          controller.destroy();
        }
      });
      this.controllers = [];
    }
  }, {
    key: "enter",
    value: function enter() {
      var promises = [];
      this.controllers.forEach(function (controller) {
        var promise = typeof controller.enter === 'function' ? controller.enter() : undefined;

        if (typeof promise !== 'undefined') {
          promises.push(promise);
        }
      });
      return Promise.all(promises);
    }
  }, {
    key: "leave",
    value: function leave() {
      var promises = [];
      this.controllers.forEach(function (controller) {
        var promise = typeof controller.leave === 'function' ? controller.leave() : undefined;

        if (typeof promise !== 'undefined') {
          promises.push(promise);
        }
      });
      return Promise.all(promises);
    } // Methods
    // --------------------------------------------------

  }, {
    key: "dispatch",
    value: function dispatch() {
      var _this = this;

      var $controllers = this.app.$html.find(this.options.selector);
      var promises = [];
      this.promise = new Defer(); // search if there are inline controllers

      if ($controllers.length) {
        Array.from($controllers).forEach(function (elm) {
          var name = $d(elm).data(_this.options.dataProp);

          var handler = _this.app.$controllers.get(name);

          if (handler !== false) {
            promises.push(_this.load(name, elm, handler));
          }
        });
      } // check for resolved promises


      Promise.all(promises).then(function () {
        // sort controllers by execution priority
        _this.controllers.sort(function (a, b) {
          // eslint-disable-next-line no-underscore-dangle
          var prioA = a._priority || 0; // eslint-disable-next-line no-underscore-dangle

          var prioB = b._priority || 0;
          if (prioA < prioB) return -1;
          if (prioA > prioB) return 1;
          return 0;
        }); // now initialize controllers


        _this.controllers.forEach(function (controller) {
          if (typeof controller.init === 'function') {
            var _controller$init;

            var args = [controller.options];

            (_controller$init = controller.init).apply.apply(_controller$init, [controller].concat(args));
          }
        });

        _this.promise.resolve();
      }).catch(function () {
        return _this.promise.reject();
      });
      return this.promise;
    }
  }, {
    key: "load",
    value: function load(name, element, Handler) {
      var _this2 = this;

      return new Promise(function (resolve) {
        var controller = new Handler(element, name);
        controller.app = _this2.app;

        _this2.controllers.push(controller);

        resolve(controller);
      });
    }
  }, {
    key: "find",
    value: function find(Module, selector) {
      var _this3 = this;

      for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        args[_key - 2] = arguments[_key];
      }

      var $elements = this.app.$body.find(selector);

      if (!$elements.length) {
        return [];
      }

      var instances = [];
      Array.from($elements).forEach(function (elm) {
        var instance = _construct(Module, [elm].concat(args));

        _this3.components.set(elm, instance);

        instances.push(instance);
      });
      return instances;
    }
  }, {
    key: "register",
    value: function register(Module, key) {
      for (var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      var instance = _construct(Module, args);

      this.components.set(key, instance);
    } // Getters & setters
    // --------------------------------------------------

  }, {
    key: "controllers",
    get: function get() {
      return this._controllers;
    } // Static methods
    // --------------------------------------------------
    ,
    set: function set(controllers) {
      this._controllers = isArray(controllers) ? controllers : [];
    }
  }], [{
    key: "install",
    value: function install() {
      this.$dispatcher = new Dispatcher();
      this.$dispatcher.app = this;
      return this;
    }
  }]);

  return Dispatcher;
}();

export default Dispatcher;

if (module.hot) {
  module.hot.accept(function (err) {
    if (err) {
      console.error(err);
    }
  });
}